<template>
    <v-data-table
            :items-per-page="10"
            must-sort
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :headers="headers"
            :items="items"
            :loading="loading"
            :search="trackSearch"
            loading-text="Loading... Please wait"
          >
            <template v-slot:top>
              <v-toolbar
                flat
              >
                <v-text-field
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  v-model="trackSearch"
                />
              <v-spacer></v-spacer>
              <slot name="top">
              </slot>
              </v-toolbar>
            </template>

            <template v-slot:item.player="{ item }">
              <audio
                controls
                preload="none"
                :src="item.public_link">
                Your browser does not support the
                <code>audio</code> element.
              </audio>
            </template>

            <template v-slot:item.additional="{ item }">
              <slot
                name="additional"
                v-bind:item="item"
              ></slot>
            </template>

            <template v-slot:item.actions="{ item }">
              <slot
                name="actions"
                v-bind:item="item"
              ></slot>
            </template>

          </v-data-table>
</template>

<script>

export default {
  name: 'AudioList',
  props: {
    loading: Boolean,
    items: [],
  },
  data() {
    return {
      // items: [],
      sortBy: 'id',
      sortDesc: false,
      id: null,
      trackSearch: '',
      headers: [
        { text: 'audio id', value: 'id', width: '20px' },
        { text: '', value: 'player', sortable: false },
        {
          text: '',
          value: 'additional',
          sortable: false,
        },
        { text: 'description', value: 'description' },
        {
          text: '',
          value: 'actions',
          sortable: false,
          width: '150px',
        },
      ],
    };
  },
};
</script>
